
import { mapGetters } from 'vuex'
import Timer from '@/mixins/timer'
export default {
  name: 'Blank',
  mixins: [Timer],
  fetch() {
    this.$store.dispatch('cart/CART_LOAD')
  },
  head() {
    const i18nSeo = this.$nuxtI18nSeo()
    return {
      ...i18nSeo,
      title: this.$t('meta.title')
    }
  },
  fetchOnServer: false,
  computed: {
    ...mapGetters({
      cartOpen: 'cart/open',
      cartRoutes: 'router/cartRoutes'
    }),
    cartControlVisible() {
      return this.count > 0
    }
  },
  watch: {
    '$i18n.locale': {
      handler() {
        this.$fetch()
      }
    }
  },
  async mounted() {
    // try {
    //   await this.$recaptcha.init()
    // } catch (e) {
    //   console.log(e)
    // }
  }
}
